import './App.css';
import Home from './page/home.js';
import Modal from './component/modal.js';
import React from 'react';
import CryptoJS from 'crypto-js';

import whatsNew from './image/whats_new_icon.svg';

import {findAll, updateItem, createPassword} from './services/firestoreHelper.js'
import {setCookie, getCookie} from './services/cookies.js'
import WhatsNew from './component/whatsNew.js';

import { getRCString } from "./services/remoteConfigHelper.js";
import WarningMessage from './component/warningMessage.js';

const whatsNewIconStyle = {
  width: "50px",
  position: "fixed",
  bottom: "0",
  right: "0",
  margin: "0px 10px 10px 0px",
  cursor: 'pointer'
}

class App extends React.Component {
  state = {
    itemList: [],
    userList: [],
    connected: "",
    userId: "",
    isModalOpen: true,
    openWhatsNew: false,
    warningMessage: "",
    isUserNotFound: false,
    startDate: "",
    endDate: ""
  }

  componentDidMount() {

    const wait = (ms) => new Promise(res => setTimeout(res, ms))

    const fetchData = async () => {
      console.log('App: fetchData start')
      const userType = this.getLoggedCookie("userType")
      const userId = this.getLoggedCookie("userId")
      console.log('App: cookies', { userId, userType })

      // si pas d'userId valide, charger la liste des users
      try {
        if (!userId || userId === "undefined") {
          const user = await findAll("user")
          console.log('App: fetched users count =', Array.isArray(user) ? user.length : 0)
          this.setState({ userList: user || [] })
        } else {
          this.closeModal()
          this.loggin(userId, userType)
        }
      } catch (err) {
        console.error('App: error fetching users', err)
        this.setState({ userList: [] })
      }

      // retry remote config reads for dates (fails parfois au refresh si RC pas encore activé)
      const maxAttempts = 5
      let start_date, end_date, parsedStart = null, parsedEnd = null, paramValue = ""

      for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        try {
          paramValue = await getRCString('warning_message') || ""
          start_date = await getRCString('start_date')
          end_date = await getRCString('end_date')
        } catch (e) {
          console.warn('App: getRCString failed on attempt', attempt, e)
          start_date = end_date = null
        }

        if (start_date && end_date) {
          parsedStart = Date.parse(start_date)
          parsedEnd = Date.parse(end_date)
          if (!isNaN(parsedStart) && !isNaN(parsedEnd)) break
        }

        // petit délai avant le prochain essai
        await wait(300)
      }

      if (parsedStart === null || isNaN(parsedStart) || parsedEnd === null || isNaN(parsedEnd)) {
        console.warn('Remote config dates invalid or missing after retries', { start_date, end_date })
        parsedStart = null
        parsedEnd = null
      }

      this.setState({
        warningMessage: paramValue || "",
        startDate: parsedStart,
        endDate: parsedEnd
      }, () => console.log('App: fetchData done', { startDate: parsedStart, endDate: parsedEnd, warningMessage: paramValue }))
    }

    fetchData()
  }

  loggin(userId, userType) {
    const uid = userId || ""
    const connected = userType || ""

    this.setState({ userId: uid, connected }, () => {
      if (connected) this.fetchItems()
    })

    this.setLoggedCookie(uid, connected)
  }

  fetchUser() {
    const fetch = async () => {
      const user = await findAll("user")
      this.setState({userList: user})

      const paramValue = await getRCString('warning_message');
      this.setState({warningMessage: paramValue})
    }

    fetch()
  }

  fetchItems() {
    const fetch = async () => {
      const items = await findAll("item")
      this.setState({itemList: items})
    }

    fetch()
  }

  setLoggedCookie(userId, userType) {
    setCookie("userId", userId, 1)
    setCookie("userType", userType, 1)
  }

  getLoggedCookie(cookieName) {
    return getCookie(cookieName)
  }

  checkUser(pseudo, password) {
    var hashPassword = CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex);
    return this.state.userList.find(it => it.pseudo.toLowerCase() === pseudo.toLowerCase() && it.password === hashPassword) !== undefined
  }

  checkConnexion(pseudo, password) {
    if(pseudo==="admin" && password==="pa$$word") {
      this.loggin('', "admin")
      this.setState({isUserNotFound: false})
    } else if(this.checkUser(pseudo, password)) {
      this.loggin(this.state.userList.find(it => it.pseudo.toLowerCase() === pseudo.toLowerCase()).id, "user")
      this.setState({isUserNotFound: false})
    } else if(this.state.userList.find(it => it.pseudo.toLowerCase() === pseudo.toLowerCase() && it.password === undefined) !== undefined){
      var userPos = this.state.userList.findIndex(it => it.pseudo.toLowerCase() === pseudo.toLowerCase() && it.password === undefined)
      var user = this.state.userList[userPos]
      user.password = CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex);
      createPassword(user.id, user)
      
      this.loggin(user.id, "user")
    } else {
      this.setState({connected: ""})
      this.setState({isUserNotFound: true})
      this.setLoggedCookie(undefined, undefined)
    }
  }

  getDataForScreen() {

    let now = Date.now()
    let isWishlistOpen = this.state.startDate < now && this.state.endDate > now

    return {
      userId: this.state.userId,
      connected: this.state.connected,
      items: this.state.itemList,
      isOpen: isWishlistOpen,
      startDate: this.state.startDate,
      endDate: this.state.endDate
    }
  }

  offerButton(userId, itemId) {
    var tempList = this.state.itemList
    var posItem = tempList.findIndex(elem => elem.id === itemId);
    var item = tempList[posItem]

    item.giftedBy = userId

    tempList[posItem] = item

    this.setState({itemList: tempList})

    updateItem(itemId, item)
  }

  closeModal() {
    this.setState({isModalOpen: false})
  }

  openWhatsNew() {
    this.setState({openWhatsNew: true})
  }

  closeWhatsNew() {
    this.setState({openWhatsNew: false})
  }

  logout() {
    this.setState({ userId: "", connected: "" }, () => {
    this.setLoggedCookie("", "")
    this.fetchUser()
    })
  }

  render() {
    return (
      <div>
        <Home connexion={this.checkConnexion.bind(this)} data={this.getDataForScreen()} offerButton={this.offerButton.bind(this)} logoutUser={this.logout.bind(this)} userNotFound={this.state.isUserNotFound}/>
        {this.state.warningMessage !== "" && !this.state.connected ? <WarningMessage message={this.state.warningMessage}/> : console.log(!this.state.connected)}
        {this.state.isModalOpen ? <Modal closeModal={this.closeModal.bind(this)}/> : console.log("modal is closed")}
        {this.state.openWhatsNew ? <WhatsNew closeModal={this.closeWhatsNew.bind(this)}/> : console.log("What's new is closed")}
        <img src={whatsNew} alt="Les nouveautés" title="Les nouveautés" style={whatsNewIconStyle} onClick={() => this.openWhatsNew()}/>
      </div>
    );
  }
}

export default App;
